import { render } from "./IconModal.vue?vue&type=template&id=bdd0e938&scoped=true"
import script from "./IconModal.vue?vue&type=script&lang=js"
export * from "./IconModal.vue?vue&type=script&lang=js"

import "./IconModal.vue?vue&type=style&index=0&id=bdd0e938&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-bdd0e938"

export default script